import { API_CREDENTIALS, API_ENDPOINTS } from "./apiEndpoints";
import axiosClient from "./axiosClient";
import Cookies from "js-cookie";

export const sendConfirmEmail = ({ emailData }) => {
  const email = Cookies.get("email");
  const customerId = Cookies.get("customerId");

  return axiosClient.post(
    API_ENDPOINTS.SEND_CONFIRM_TO_EMAIL,
    {
      customer_id: customerId,
      email: email,
      ...emailData,
    },
    {
      headers: {
        "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
        "Accept-Language": "en",
        platform: "android",
        "platform-key": "387666a26a0ad869c9.00802837",
        "leap-customer": "yes",
        email: email,
      },
    }
  );
};
